<!-- 视频双选会卡片 -->
<template>
    <el-card class="card-box" :body-style="{ padding: '0px' }" shadow="always">
        <div class="card-img">
            <el-image style="width:100%; height: 100%;" :src="tranUrl(item.img)" fit="cover" :lazy="lazy">
                <div slot="placeholder" class="image-slot">
                    加载中
                    <span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">
                    <img :src="$util.error_img_jobfair" style="height: 100%"/>
                </div>
            </el-image>
        </div>
        <div style="padding: 15px 16px;">
            <p class="tc title">{{item.name}}</p>
            <p class="tc des">{{item.start_time}}—{{item.end_time}}</p>
            <p class="tc des">{{item.organizers}}</p>
            <div class="bottom clearfix">
                <el-row>
                    <el-col :span="12">
                        <span class="highlight">{{item.nums}}</span>
                        <span>预计参加企业</span>
                    </el-col>
                    <el-col class="tr" :span="12">
                        <span class="highlight">{{item.stu_numb}}</span>
                        <span>预计参加学生</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="status-sign ongoing" v-if="item.current_status">{{item.current_status}}</div>
    </el-card>
</template>

<script>
  export default {
    name: 'card-box',
    props: {
      item: {
        type: Object
      },
      lazy: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      tranUrl: function (value) {
        if (value) {
          value = this.$util.tansPics(value, '', {
            style: 'w420-h168'
          })
        }
        return value
      }
    },
  }
</script>

<style lang="scss" scoped>
    .card-box {
        margin-bottom: 20px;
        position: relative;
        cursor: pointer;

        &:hover {
            @include box-shadow(5px 10px 10px 5px rgba(0, 0, 0, 0.1));
        }

        p {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .card-img {
            height: 166px;
            margin-bottom: 15px;
        }

        .title {
            font-weight: bold;
            color: #333;
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 5px;
        }

        .des {
            font-size: 12px;
            color: #999;
            margin-bottom: 15px;
            font-weight: bold;
        }

        .bottom {
            border: 1px solid rgba(243, 243, 243, 1);
            height: 32px;
            line-height: 32px;
            padding: 0 15px;

            span {
                color: #999;
                font-size: 12px;
            }

            .highlight {
                color: #0080ff;
                font-size: 14px;
                font-weight: bold;
            }
        }

        .image-slot {
            height: 100%;
            text-align: center;
            font-size: 20px;
            background-color: #f5f7fa;
        }

        .status-sign {
            position: absolute;
            left: 0;
            top: 15px;
            height: 23px;
            font-size: 12px;
            line-height: 17px;
            padding: 3px 10px;
            @include box-sizing(border-box);
            @include border-radius(0 12px 12px 0);

            &.ongoing {
                background-color: #ff4646;
                color: #fff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Card/CardJobfair.vue